import React, { useState, useEffect } from "react";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import user_pic from "../../assets/images/pic-change.png";
import docuble_arrow from "../../assets/images/icon/double-arrow.svg";

const CustomCalendar = ({ onDateChange }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  const today = new Date();

  const changeMonth = direction => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() + direction);
    setCurrentDate(newDate);
    onDateChange(newDate);
  };

  // Ensure today's date is always available
  const isDateAvailable = date => {
    const isToday = date.toDateString() === today.toDateString();
    return (
      isToday ||
      availableDates.some(
        availableDate => availableDate.toDateString() === date.toDateString()
      )
    );
  };

  const renderDays = () => {
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();
    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);
    const daysInMonth = lastDayOfMonth.getDate();

    const days = [];

    // Fill with empty days for the start of the month
    for (let i = 0; i < (firstDayOfMonth.getDay() + 6) % 7; i++) {
      days.push(<p key={`empty-${i}`}></p>);
    }

    // Fill with actual days
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const isSelected =
        selectedDate && selectedDate.toDateString() === date.toDateString();

      days.push(
        <p
          key={day}
          onClick={() => {
            setSelectedDate(date); // First statement
            onDateChange(date); // Second statement
          }}
          className={`calendar-day ${isSelected ? "selected" : ""}`}
          style={{
            cursor: "pointer",
            backgroundColor: isSelected ? "#d3e3fc" : "rgb(12 102 228 / 10%)",
            color: "#fff",
          }}
        >
          {day}
        </p>
      );
    }

    return days;
  };

  useEffect(() => {
    if (
      selectedDate &&
      (selectedDate.getMonth() !== currentDate.getMonth() ||
        selectedDate.getFullYear() !== currentDate.getFullYear())
    ) {
      setSelectedDate(new Date(currentDate));
      onDateChange(new Date(currentDate));
    }
  }, [currentDate, selectedDate]);

  console.log(selectedDate, "selectedDate");

  return (
    <section className="calendar-card">
      <div className="calender-pic">
        <img src={user_pic} alt="" />
        <h3>Harry Brook</h3>
        <p>Team Lead</p>
      </div>
      <div className="top">
        <span className="left-icon lefts" style={{ cursor: "pointer" }}>
          <img src={docuble_arrow} alt="right-arrow" />
        </span>
        <span
          className="left-icon"
          onClick={() => changeMonth(-1)}
          style={{ cursor: "pointer" }}
        >
          <img src={right_arrow} alt="right-arrow" />
        </span>

        <p>
          {currentDate.toLocaleString("default", {
            month: "long",
            year: "numeric",
          })}
        </p>
        <span
          className="right-icon"
          onClick={() => changeMonth(1)}
          style={{ cursor: "pointer" }}
        >
          <img src={right_arrow} alt="right-arrow" />
        </span>
        <span className="left-icon rigths" style={{ cursor: "pointer" }}>
          <img src={docuble_arrow} alt="right-arrow" />
        </span>
      </div>
      <div className="down">
        <p>Mon</p>
        <p>Tue</p>
        <p>Wed</p>
        <p>Thu</p>
        <p>Fri</p>
        <p>Sat</p>
        <p>Sun</p>
        {renderDays()}
      </div>
    </section>
  );
};

export default CustomCalendar;
